import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import PageWrapper from '@components/common/layout/PageWrapper';
import Loading from '@components/common/loading';
import apiConfig from '@constants/apiConfig';
import useFetch from '@hooks/useFetch';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import { showSucsessMessage } from '@services/notifyService';
import { getDetailRestaurantSuccess } from '@store/actions/restaurant';
import { Card } from 'antd';

import PrinterSettingForm from './PrinterSettingForm';

const RestaurantPrinterPage = () => {
    const translate = useTranslate();
    const dispatch = useDispatch();
    const { restaurantId } = useParams();
    const [ isGetDetailLoading, setIsGetDetailLoading ] = useState(false);
    const [ dataDetail, setDataDetail ] = useState({});
    const [ isChangedFormValues, setIsChangedFormValues ] = useState(false);

    const getDetail = (restaurantId) => {
        setIsGetDetailLoading(true);
        executeGet({
            pathParams: { id: restaurantId },
            onCompleted: (response) => {
                const mappedData = getDataDetailMapping(response.data);
                setDataDetail(mappedData);
                setIsGetDetailLoading(false);
            },
            onError: () => {
                setIsGetDetailLoading(false);
            },
        });
    };

    const prepareUpdateData = (settingObj) => {
        const newSettingObj = {
            ...dataDetail.settings,
            ...settingObj,
            printers: settingObj.printers.map(
                (
                    {
                        number,
                        is_white,
                        is_check,
                        is_print_time,
                        is_next_course,
                        is_beep,
                        is_print_separator,
                        ...rest
                    },
                    index,
                ) => ({
                    ...rest,
                    number: number || index + 1,
                    is_white: is_white || false,
                    is_check: is_check || false,
                    is_print_time: is_print_time || false,
                    is_next_course: is_next_course || false,
                    is_beep: is_beep || false,
                    is_print_separator: is_print_separator || false,
                }),
            ),
        };
        return { ...dataDetail, settings: JSON.stringify(newSettingObj) };
    };

    const getDataDetailMapping = (data) => {
        const dataDetail = { ...data };
        dataDetail.settings = JSON.parse(data.settings) || {};
        dataDetail.settings.printers = (dataDetail.settings.printers || []).sort(
            (pA, pB) => pA.number - pB.number,
        );
        return dataDetail;
    };

    const onSave = (values) => {
        const updatedData = prepareUpdateData(values);
        update({
            data: updatedData,
            onCompleted: (res) => {
                showSucsessMessage(translate.formatMessage(commonMessage.updatePrinterSuccess), translate);
                executeGet({
                    pathParams: { id: restaurantId },
                    onCompleted: (response) => {
                        const mappedData = getDataDetailMapping(response.data);
                        setDataDetail(mappedData);
                        dispatch(getDetailRestaurantSuccess({ payload: { data: response.data } }));
                        setIsGetDetailLoading(false);
                    },
                });
            },
            onError: () => {},
        });
    };

    const { execute: executeGet, loading } = useFetch(apiConfig.restaurant.getById, {
        immediate: false,
    });

    const { execute: update, loading: loadingUpdate } = useFetch(apiConfig.restaurant.updateByCustomer);

    useEffect(() => {
        if (restaurantId) {
            getDetail(restaurantId);
        }
    }, [ restaurantId ]);

    const renderActions = () => {
        return [];
    };

    const getFormId = () => {
        return 'printer-setting-form';
    };

    if (isGetDetailLoading) {
        return <Loading />;
    }

    return (
        <PageWrapper
            loading={loading}
            routes={[ { breadcrumbName: translate.formatMessage(commonMessage.printers) } ]}
        >
            <div className="basic-form-page">
                <Card title={translate.formatMessage(commonMessage.printerManagement)} bordered={false} actions={renderActions()}>
                    <PrinterSettingForm
                        formId={getFormId()}
                        onSubmit={onSave}
                        settingObj={dataDetail.settings || {}}
                        setIsChangedFormValues={setIsChangedFormValues}
                        isChangedFormValues={isChangedFormValues}
                        loadingUpdate={loadingUpdate}
                    />
                </Card>
            </div>
        </PageWrapper>
    );
};

export default RestaurantPrinterPage;